import React from 'react';

import { TestCoreComponentProps } from '@bcp-channels-sharedcomponents-reactjs/core';
import { render } from '@testing-library/react';
import { Anything } from '@types';

import { TestComponent } from '../testComponent';

interface TestHookProps {
	hookFn: () => Anything;
	state?: Record<string, Anything>;
	coreProps?: TestCoreComponentProps;
}

export const TestHook: React.FC<TestHookProps> = ({ state, coreProps, hookFn }) => {
	const Setup: React.FC = () => {
		const returnVal = {};
		function TestComp() {
			Object.assign(returnVal, hookFn());
			return null;
		}
		render(
			<TestComponent state={state} coreProps={coreProps}>
				<TestComp />
			</TestComponent>
		);
		return returnVal as Anything;
	};

	return <Setup />;
};
